export default __webpack_public_path__ + "static/media/ico02.a91bad3a.png";